import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'ehl',
} as IModuleProps;
